import { TbArrowRight } from 'react-icons/tb'
import { Heading, Text } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import { LandingSolutionsDataType } from './landingSolutionsData'
import NavLink from 'ui-kit/actions/link/NavLink'
import classes from './LandingSolutions.module.scss'

export const LandingSolutionCard = ({
  image1x,
  image2x,
  title,
  description,
  href,
}: LandingSolutionsDataType) => {
  return (
    <li className={classes.item}>
      <div className={classes.visual}>
        <Picture
          imgClassName={classes.image}
          src1x={image1x.src}
          src2x={image2x.src}
          alt={title}
          lazyLoad
        />
      </div>
      <div className={classes.content}>
        <NavLink href={href} className={classes.link}>
          <Heading as={'h3'} size={'sm'}>
            {title}
          </Heading>
          <TbArrowRight className={classes.icon} />
        </NavLink>
        <Text size={'lg'} className={classes.description}>
          {description}
        </Text>
      </div>
    </li>
  )
}
